import React from 'react';
import { Link } from 'react-router-dom';
import StatusBadge from '../../../components/ui/StatusBadge';
import { formatDate, formatRelative } from '../../../utils/format';

export default function EventCard({ event }) {
  const sessionCount = Number(event.session_count || 0);
  const cardStats = [
    { value: sessionCount, label: sessionCount === 1 ? 'session' : 'sessions' },
    event.created_at && { value: formatDate(event.created_at), label: 'created' },
    event.updated_at && { value: formatRelative(event.updated_at), label: 'last activity' },
  ].filter(Boolean);

  return (
    <Link to={`/events/${event.id}`} className="events-card">
      <div className="events-card-top">
        <StatusBadge status={event.status} />
      </div>

      <h3 className="events-card-title">{event.title || 'Untitled event'}</h3>
      {event.description && <p className="events-card-desc">{event.description}</p>}

      {cardStats.length > 0 && (
        <div className="events-card-foot">
          {cardStats.map((stat) => (
            <div key={stat.label} className="events-card-stat">
              <span>{stat.value}</span>
              <small>{stat.label}</small>
            </div>
          ))}
        </div>
      )}
    </Link>
  );
}
